/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampCategoryDto } from '../../models/camp-category-dto';
import { CampCategoryShowResponse } from '../../models/camp-category-show-response';

export interface PostCampCategoryCreate$Params {
      body: CampCategoryDto
}

export function postCampCategoryCreate(http: HttpClient, rootUrl: string, params: PostCampCategoryCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampCategoryShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postCampCategoryCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampCategoryShowResponse>;
    })
  );
}

postCampCategoryCreate.PATH = '/v1/camp-category';
